<template>
  <div class="dispute-status">
    <span class="dispute-status-name">Dispute status</span>
    <Button
      :class="[
        'dispute-status-dropdown',
        { 'dispute-status-dropdown--disabled': disabled },
        getClassName,
      ]"
      :icon="icon"
      :label="disputeStatus.displayName"
      :disabled="disabled"
      @onClick="handleDisputeStatusDropdown($event)" />
  </div>
</template>

<script>
// Configs
import { disputeStatusList } from "@/config/constant.js";

export default {
  name: "DisputeStatus",
  props: {
    disputeStatus: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disputeStatusList: disputeStatusList,
      icon: "chevron-right",
    };
  },
  computed: {
    getClassName() {
      return ["10: New", "20: In Process"].indexOf(
        this.disputeStatus.displayName
      ) > -1
        ? "dispute-status-dropdown--in-progress"
        : [
            "60: Accepted",
            "61: Accepted - Manual Credit Note / PB",
            "62: Accepted - No Change",
            "63: Accepted - Invoice cancellation and rebill",
          ].indexOf(this.disputeStatus.displayName) > -1
        ? "dispute-status-dropdown--accepted"
        : [
            "66: Collectable - Rejected with evidence",
            "67: Collectable - Rejected post validation",
            "70: Collectable",
            "71: Collectable - Customer Agreement",
            "72: Collectable - Customer Disagrees",
            "73: Collectable - Missing / Incomplete Info",
            "74: Collectable - Waiver Approved",
            "78: Collectable - Not a dispute",
          ].indexOf(this.disputeStatus.displayName) > -1
        ? "dispute-status-dropdown--collectable-incomplete-info"
        : ["30: Potential Reject", "75: Redisputed"].indexOf(
            this.disputeStatus.displayName
          ) > -1
        ? "dispute-status-dropdown--potential-reject"
        : "";
    },
  },
  methods: {
    handleDisputeStatusDropdown(event) {
      event.preventDefault();
      this.$emit("disputeStatusDropdown");
    },
  },
};
</script>

<style lang="scss">
.dispute-status {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &-name {
    font-family: "Maersk Text";
    font-size: 1em;
  }

  .dispute-status-dropdown {
    border: none;
    border-radius: 0.25rem;
    color: var(--Gray-50);
    text-transform: capitalize;
    font-family: "Maersk Text";
    padding: 1rem;
    text-align: left;
    width: 24rem;

    &--disabled {
      background: rgba(0, 36, 61, 0.5) !important;
      &:hover {
        background: rgba(0, 36, 61, 0.5) !important;
      }
    }

    &--in-progress {
      background: var(--Blue-700);
      &:hover {
        background: var(--Blue-800);
      }
    }

    &--accepted {
      background: var(--Teal-500);
      &:hover {
        background: var(--Teal-700);
      }
    }

    &--collectable-incomplete-info {
      background: var(--Orange-700);
      &:hover {
        background: var(--Orange-800);
      }
    }

    &--potential-reject {
      background: var(--Red-700);
      &:hover {
        background: var(--Red-800);
      }
    }
  }
}
</style>
